/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_20_To_50_Of_Your_Favorite_Moments_From_ThisInputs */

const en_select_20_to_50_of_your_favorite_moments_from_this = /** @type {(inputs: Select_20_To_50_Of_Your_Favorite_Moments_From_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select 20-50 of your favourite moments from this trip, journey, or occasion.`)
};

const es_select_20_to_50_of_your_favorite_moments_from_this = /** @type {(inputs: Select_20_To_50_Of_Your_Favorite_Moments_From_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona entre 20 y 50 de tus momentos favoritos de este viaje o evento.`)
};

const fr_select_20_to_50_of_your_favorite_moments_from_this = /** @type {(inputs: Select_20_To_50_Of_Your_Favorite_Moments_From_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez 20 à 50 de vos moments préférés de ce voyage ou événement.`)
};

const de_select_20_to_50_of_your_favorite_moments_from_this = /** @type {(inputs: Select_20_To_50_Of_Your_Favorite_Moments_From_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie 20 bis 50 Ihrer Lieblingsmomente von dieser Reise oder diesem Anlass aus.`)
};

const ja_select_20_to_50_of_your_favorite_moments_from_this = /** @type {(inputs: Select_20_To_50_Of_Your_Favorite_Moments_From_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この旅行、旅、または行事からお気に入りの瞬間を20〜50枚選択してください。`)
};

const zh_select_20_to_50_of_your_favorite_moments_from_this = /** @type {(inputs: Select_20_To_50_Of_Your_Favorite_Moments_From_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从这次旅行或活动中选择20到50个您最喜欢的时刻。`)
};

const ar_select_20_to_50_of_your_favorite_moments_from_this = /** @type {(inputs: Select_20_To_50_Of_Your_Favorite_Moments_From_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختر 20-50 من لحظاتك المفضلة من هذه الرحلة أو المناسبة.`)
};

const id_select_20_to_50_of_your_favorite_moments_from_this = /** @type {(inputs: Select_20_To_50_Of_Your_Favorite_Moments_From_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih 20-50 momen favorit Anda dari perjalanan, petualangan, atau acara ini.`)
};

const it_select_20_to_50_of_your_favorite_moments_from_this = /** @type {(inputs: Select_20_To_50_Of_Your_Favorite_Moments_From_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona 20-50 dei tuoi momenti preferiti di questo viaggio o evento.`)
};

const ru_select_20_to_50_of_your_favorite_moments_from_this = /** @type {(inputs: Select_20_To_50_Of_Your_Favorite_Moments_From_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите 20-50 ваших любимых моментов из этой поездки, путешествия или события.`)
};

const pt_select_20_to_50_of_your_favorite_moments_from_this = /** @type {(inputs: Select_20_To_50_Of_Your_Favorite_Moments_From_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione 20 a 50 dos seus momentos favoritos desta viagem, jornada ou ocasião.`)
};

const ko_select_20_to_50_of_your_favorite_moments_from_this = /** @type {(inputs: Select_20_To_50_Of_Your_Favorite_Moments_From_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이번 여행, 여정 또는 특별한 날에서 가장 좋아하는 순간을 20~50개 선택하세요.`)
};

/**
* | output |
* | --- |
* | "Select 20-50 of your favourite moments from this trip, journey, or occasion." |
*
* @param {Select_20_To_50_Of_Your_Favorite_Moments_From_ThisInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const select_20_to_50_of_your_favorite_moments_from_this = /** @type {((inputs?: Select_20_To_50_Of_Your_Favorite_Moments_From_ThisInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_20_To_50_Of_Your_Favorite_Moments_From_ThisInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_select_20_to_50_of_your_favorite_moments_from_this(inputs)
	if (locale === "es") return es_select_20_to_50_of_your_favorite_moments_from_this(inputs)
	if (locale === "fr") return fr_select_20_to_50_of_your_favorite_moments_from_this(inputs)
	if (locale === "de") return de_select_20_to_50_of_your_favorite_moments_from_this(inputs)
	if (locale === "ja") return ja_select_20_to_50_of_your_favorite_moments_from_this(inputs)
	if (locale === "zh") return zh_select_20_to_50_of_your_favorite_moments_from_this(inputs)
	if (locale === "ar") return ar_select_20_to_50_of_your_favorite_moments_from_this(inputs)
	if (locale === "id") return id_select_20_to_50_of_your_favorite_moments_from_this(inputs)
	if (locale === "it") return it_select_20_to_50_of_your_favorite_moments_from_this(inputs)
	if (locale === "ru") return ru_select_20_to_50_of_your_favorite_moments_from_this(inputs)
	if (locale === "pt") return pt_select_20_to_50_of_your_favorite_moments_from_this(inputs)
	return ko_select_20_to_50_of_your_favorite_moments_from_this(inputs)
});